const config = {
    threshold: 1
};

const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if( entry.intersectionRatio > 0 ) {
            entry.target.classList.add('show--el');
            observer.unobserve(entry.target);
        } else {
            entry.target.classList.remove('show--el');
        }
    })

});

window.addEventListener('load', () => {
    var el = document.querySelectorAll(".view--el");
    el.forEach(el => {
        observer.observe(el)
    });
});